// A saved search: its results, with refinements kept attached so they can be saved back.
import { useParams, useSearchParams } from "react-router";
import type { Sort } from "../api/search";
import { useSavedSearches } from "../app/queries";
import { SearchResults, useWidePage } from "./Search";

export function Saved() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const searches = useSavedSearches();
  useWidePage();
  if (searches.isPending) return <p className="empty">Loading…</p>;
  const saved = (searches.data ?? []).find((s) => s.id === Number(id));
  if (!saved) return <p className="empty">That saved search no longer exists.</p>;
  const q = params.get("q") ?? saved.query;
  const sort = ((params.get("sort") as Sort | null) ?? saved.sort) || "best";
  return <SearchResults key={`${saved.id}|${q}|${sort}`} q={q} sort={sort} saved={saved} />;
}
